<template>
    <div>
      <textarea
        v-model="model.void_reason"
        :placeholder="placeholder"
        rows="3"
        class="form-control"
        :class="{ 'is-invalid': errors.has('void_reason') }"
      ></textarea>
      <div class="invalid-feedback" v-if="errors.has('void_reason')">
        {{ errors.first('void_reason') }}
      </div>
    </div>
  </template>
  <script>
  import { Errors } from 'form-backend-validation'
  export default {
    name: 'reasonDelete',
    props: ['value', 'validate', 'placeholder'],
    data() {
      return {
        model: {},
        errors: new Errors()
      }
    },
    created() {
      this.model = this.value
    },
    methods: {},
    watch: {
      validate: function(error) {
        this.errors = new Errors(error.errors)
      }
    }
  }
  </script>
  